module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meu-perfil"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "perfil-items"
  }, [_c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("E-mail Acadêmico")]), _vm._v(" "), (!_vm.carregandoEmailAcademico) ? _c('div', {
    staticClass: "perfil-text"
  }, [(_vm.emailAcademico) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.emailAcademico))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.alterarSenhaEmailAcademico
    }
  }, [_c('i', {
    staticClass: "fas fa-lock"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Alterar Senha")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.emailAcademico) ? _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.criarEmailAcademico()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Criar Email Acadêmico")])]) : _vm._e()], 1) : _c('div', {
    staticClass: "perfil-text"
  })]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Celular")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_vm._v(_vm._s(_vm.data.pessoa_fisica.fone_celular))])]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_vm._v(_vm._s(_vm.data.pessoa_fisica.fone_residencial || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_vm._v(_vm._s(_vm._f("dateEnToBr")(_vm.data.pessoa_fisica.dt_nascimento)))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "perfil-items"
  }, [_c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("SMS")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_vm._v(_vm._s(_vm.data.pessoa_fisica.fl_aceita_sms ? 'Sim' : 'Não'))])]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Notas")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_vm._v(_vm._s(_vm.data.usuario.notificacoes_notas ? 'Sim' : 'Não'))])]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Provas")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_vm._v(_vm._s(_vm.data.usuario.notificacoes_provas ? 'Sim' : 'Não'))])]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Agenda")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_vm._v(_vm._s(_vm.data.usuario.notificacoes_agenda ? 'Sim' : 'Não'))])]), _vm._v(" "), _c('div', {
    staticClass: "perfil-item"
  }, [_c('div', {
    staticClass: "perfil-label"
  }, [_vm._v("Boletos")]), _vm._v(" "), _c('div', {
    staticClass: "perfil-text"
  }, [_vm._v(_vm._s(_vm.data.usuario.notificacoes_boletos ? 'Sim' : 'Não'))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "meu-perfil-titulo"
  }, [_c('i', {
    staticClass: "fas fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Perfil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "meu-perfil-titulo"
  }, [_c('i', {
    staticClass: "fas fa-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Notificações e SMS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08ed208c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/pessoal/components/minha-conta/Inicial.vue
// module id = 520
// module chunks = 2